import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import LoginOidcCallback from '../views/LoginOidcCallback.vue'
import PropertyDetail from '@/views/PropertyDetail.vue'
import PropertyDetailEmbed from '@/views/PropertyDetailEmbed.vue'
import TextInfoChanges from '@/views/TextInfoChanges.vue'
import ActiveConnectionList from '@/views/ActiveConnectionList.vue'
import Password from '@/views/Password.vue'
import SurveyList from '@/views/SurveyList.vue'
import ProductCatalogList from '@/views/ProductCatalogList.vue'
import ProductCatalogDetail from '@/views/ProductCatalogDetail.vue'
import ExpirationsView from '@/views/ExpirationsView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: {
      name: 'home',
    },
    component: () => import('../layouts/Default.vue'),
    children: [
      {
        path: 'properties/:id/',
        name: 'property-detail',
        component: PropertyDetail,
        props: (route) => ({ id: Number(route.params.id) }),
      },
      {
        path: 'properties/:propertyId/changes/:product',
        name: 'text-info-changes',
        component: TextInfoChanges,
        props: true,
      },
      {
        path: 'connections',
        name: 'connections',
        component: ActiveConnectionList,
      },
      {
        path: 'password',
        name: 'password',
        component: Password,
      },
      {
        path: 'surveys',
        name: 'surveys',
        component: SurveyList,
      },
      {
        path: 'products',
        name: 'products',
        component: ProductCatalogList,
      },
      {
        path: 'products/:id',
        name: 'product-detail',
        component: ProductCatalogDetail,
        props: (route) => ({ id: Number(route.params.id) }),
      },
      {
        path: 'expirations',
        name: 'expirations',
        component: ExpirationsView,
      },
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: { auth: false },
      },
      {
        path: 'login/oidc-callback',
        name: 'login-oidc-callback',
        component: LoginOidcCallback,
        meta: { auth: false },
      },
      {
        path: '',
        name: 'home',
        component: Home,
      },
    ],
  },
  {
    path: '/customer-tasks/:token',
    name: 'customer-tasks',
    component: () => import('../views/CustomerTasks.vue'),
    meta: { auth: false },
  },
  {
    path: '/customer-survey/:id',
    name: 'customer-survey',
    component: () => import('../components/SurveyForm.vue'),
  },
  {
    path: '/embed',
    component: () => import('../layouts/Embed.vue'),
    children: [
      {
        path: 'properties/:id/',
        name: 'property-detail-embed',
        component: PropertyDetailEmbed,
        props: (route) => ({ id: Number(route.params.id) }),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
